//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class ProductSeoService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[ProductSeo.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/store/product-seo/create', params || { });
	};

	//GeneratorFlag:[ProductSeo.Delete]
	async delete(productId, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		const params = {
			id:productId
		}
	
		return await _server.delete('/store/product-seo/delete', {'params':params})
	};

	//GeneratorFlag:[ProductSeo.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/store/product-seo/detail', {'params':params});
	};

	//GeneratorFlag:[ProductSeo.Update]
	async update(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/store/product-seo/update', params || { });
	};

//GeneratorFlag:[NewAction]
}